import {
  PageTitle, Upload, BottomButtons, ErrorBar,
} from '@components';
import { ClaimType, ALLOWED_UPLOAD_TYPE } from '@constants';
import { Snackbar, Alert } from '@mui/material';
import classes from './index.module.css';
import { useUpload } from './hooks';
import {
  uploadInfoMap, TITLE_TEXT,
  // MAX_UPLOAD_AMOUNT_LIMIT,
} from './const';

export default function UploadPage() {
  const {
    type,
    files, files1, filesName,
    inputValue,
    isLoading,
    showToast,
    toastText,
    showFailedToast,
    failedToastText,
    // totalMoney,
    comments,
    onCommentsChange,
    onCloseFailedToast,
    handleChange,
    deleteFile,
    onClickContinue,
    onClickBack,
    onCloseToast,
  } = useUpload();

  const commentPart = (number) => (
    <>
      <div className={classes.header_tip}>
        {`${number}. Enter comments explaining the issue.`}
      </div>
      <textarea
        rows={3}
        className={classes.input_comments}
        onChange={onCommentsChange}
        value={comments || ''}
        placeholder=" Max 1,000 characters"
        maxLength="1000"
      >
      </textarea>
    </>
  );
  const uploadContent = (type) => {
    const uploadList = uploadInfoMap[type] || [];
    const len = uploadList.length;
    return uploadList.map((item, index) => {
      const {
        title, helpText, isRequired,
      } = item;
      return (
        <div key={title}>
          <div className={classes.header_tip}>
            {isRequired && <span className={classes.isRequired}>*</span>}
            {title}
            {/* {moreLink ? (
              <span>
                {' Learn more about '}
                <a className={classes.link} href={moreLink} target="_blank" rel="noreferrer">{moreText}</a>
                .
              </span>
            ) : null} */}

          </div>
          <Upload
            files={filesName[index]}
            accept={ALLOWED_UPLOAD_TYPE}
            inputValue={inputValue}
            handleChange={(e) => handleChange(e, index)}
            deleteFile={(v) => deleteFile(v, index)}
            key={title}
            style={{ boxShadow: 'initial', marginTop: 0 }}
          >
            <span>{helpText}</span>
          </Upload>

          {index === len - 1 && commentPart(len + 1)}

        </div>

      );
    });
  };

  // loss theft 当金额大于300时，common 上传才必填附件
  // const isDisabled = ([ClaimType.Loss, ClaimType.Theft].includes(type) ? (totalMoney >= MAX_UPLOAD_AMOUNT_LIMIT
  //   && !files.length) : !files.length) || (type === ClaimType.Damage ? !files1.length : false);

  const isDisabled = type === ClaimType.Loss
    ? !files.length : (!files.length || !files1.length);
  return (
    <section className={classes.content}>
      <PageTitle title={TITLE_TEXT} />
      <section className={classes.header_tip}>
        Thorough details help us understand the problem and process your claim faster.
      </section>
      {/* 提示 toast */}
      {showToast ? (
        <ErrorBar className={classes.error} message={toastText} canClose onClose={onCloseToast} />
      ) : null}
      <div className={classes.card}>

        {uploadContent(type)}
      </div>
      <BottomButtons
        isContinueDisabled={isDisabled}
        isContinueLoading={isLoading}
        onClickContinue={onClickContinue}
        onClickBack={onClickBack}
      />

      {showFailedToast ? (
        <Snackbar
          className={classes.bottom_toast}
          open={showFailedToast}
          anchorOrigin={{
            horizontal: 'center',
            vertical: 'bottom',
          }}
          autoHideDuration={3000}
          onClose={onCloseFailedToast}
        >
          <Alert
            icon={false}
            severity="error"
            className={classes.failed_toast}
            onClose={onCloseFailedToast}
          >
            {failedToastText}
          </Alert>
        </Snackbar>
      ) : null}
    </section>
  );
}
